#import "@/apollo/fragments/ComputedDeliverableStatus.gql"

mutation SetComputedDeliverablesStatus(
    $campaignId: ID!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $globalStatus: ComputedDeliverableQAStatuses
    $userStatus: ComputedDeliverableUserQAStatuses
) {
    setComputedDeliverablesQAStatus(
        campaignId: $campaignId
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
        globalStatus: $globalStatus
        userStatus: $userStatus
    ) {
        ...ComputedDeliverableStatus
    }
}
